export default function SheetSkeleton () {
  return (
    <div className='border border-gray-200 rounded-md p-2 bg-white h-[70vh]'>
      <div className='animate-pulse space-y-1'>
        <div className='h-8 bg-gray-200 rounded w-full' />
        {[...Array(20)].map((_, rowIdx) => (
          <div key={rowIdx} className='flex space-x-0.5'>
            {Array.from({ length: 10 }).map((_, cellIdx) => (
              <div key={cellIdx} className='h-6 bg-gray-100 rounded w-full' />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
